import React, { useEffect, useState } from "react";
import { Button, Switch } from "antd";
import { ErrorToast, SuccessToast } from "../../../../widgets/AppToast";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
import useUserData from "../../../../hooks/useUserData";
import moment from "moment";
import UnitWithInput from "../../../../components/UnitWithInput";
import { useDate } from "../../../../context/DateContext";

export const OtherPlants = ({ eng_log_basic_id, _items }) => {
  const user = useUserData();
   const { selectedDate } = useDate();
  const [loader, set_loader] = useState(false);
  const [errors, set_errors] = useState({});
  const [staff_dashboard, set_staff_dashboard] = useState([]);
  const [checked, setChecked] = useState(false);
  const [update_status, set_Update_Status] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(false);

  const [logDate, set_LogDate] = useState(moment().format("YYYY-MM-DD HH:mm:ss"));
  const [otherParams, setOtherParams] = useState({});


  useEffect(() => {
    const staff_dashboards = localStorage.getItem("staff_dashboard");
    const parsedData = JSON.parse(staff_dashboards);
    set_staff_dashboard(parsedData);
    if (parsedData && _items) {
      if (_items?.id) VIEW_AUXILARY_MACHINARY_DETAILS_LOGBOOK_API(_items?.id, parsedData);
      const otherParamsData = Array.isArray(_items?.other_parameters)
        ? _items.other_parameters
        : [];
      const initialOtherParams = otherParamsData.reduce((acc, param) => {
        acc[param.name] = { value: "", unit: param.unit || "" };
        return acc;
      }, {});
      setOtherParams(initialOtherParams);
    }
  }, [_items?.id]);

  const onChangeDateTime = (value) => {
    if (value) {
      set_LogDate(value.format("YYYY-MM-DD HH:mm:ss"));
    } else {
      set_LogDate(null);
    }
  };

  const handleOtherParamChange = (name, field, value) => {
    setOtherParams((prev) => ({
      ...prev,
      [name]: { ...prev[name], [field]: value },
    }));
  };

  const ADD_AUXILARY_MACHINARY_DETAILS_LOGBOOK_API = (other_plant_id, other_plant_on) => {
    set_loader(true);
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("other_tittle", `${_items?.machinary_name}`);
      FORM_DATA.append(
        "date_time_log",
        logDate || moment(new Date()).format("YYYY-MM-DD HH:mm:ss")
      );
      FORM_DATA.append("eng_log_basic_id", Number(eng_log_basic_id) || 0);
      FORM_DATA.append("voyage_id", Number(staff_dashboard?.voyage_details?.[0]?.id) || 0);
      FORM_DATA.append("other_on_off", other_plant_on);
      FORM_DATA.append("other_id", Number(other_plant_id) || 0);
      FORM_DATA.append("other_parameters", JSON.stringify(otherParams));
      post(ApiURL.add_auxiliary_other_machinery, FORM_DATA).then((res) => {
        if (res?.status === true) {
          set_loader(false);
          SuccessToast(
            "Logbook Add Success!",
            "Logbook Auxiliary Machinery details have been successfully added!"
          );
          VIEW_AUXILARY_MACHINARY_DETAILS_LOGBOOK_API(
            res?.other_machine_data?.other_id,
            staff_dashboard
          );
        } else {
          set_loader(false);
          const errors = res?.errors || {};
          set_errors(errors);
        }
      });
    } catch (error) {
      console.error("Error in submitting air conditioning data:", error);
      set_loader(false);
    }
  };

  const UPDATE_AUXILARY_MACHINARY_DETAILS_LOGBOOK_API = (
    other_plant_id,
    save_submit,
    other_plant_on
  ) => {
    set_loader(true);
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("save_submit", Number(save_submit) || 0);
      FORM_DATA.append(
        "date_time_log",
        logDate || moment(new Date()).format("YYYY-MM-DD HH:mm:ss")
      );
      FORM_DATA.append("eng_log_basic_id", Number(eng_log_basic_id) || 0);
      FORM_DATA.append("voyage_id", Number(staff_dashboard?.voyage_details?.[0]?.id) || 0);
      FORM_DATA.append("other_on_off", other_plant_on);
      FORM_DATA.append("other_id", Number(other_plant_id) || 0);
      FORM_DATA.append("other_tittle", `${_items?.machinary_name}`);
      FORM_DATA.append("other_parameters", JSON.stringify(otherParams));
      const rawItemParams = _items?.other_parameters || [];
      rawItemParams.forEach((param) => {
        FORM_DATA.append(`other_parameter_${param.name}`, param.value || "");
        FORM_DATA.append(`other_parameter_${param.name}_unit`, param.unit || "");
      });

      post(ApiURL.view_update_other_machinery, FORM_DATA).then((res) => {
        set_loader(false); // Hide loader once the request is finished

        if (res?.status === true) {
          SuccessToast("Logbook Update Success!", res?.message);
          // Optionally, you could trigger other necessary actions after a successful submission
          if (staff_dashboard) {
            VIEW_AUXILARY_MACHINARY_DETAILS_LOGBOOK_API(
              res?.other_machine_data?.other_id,
              staff_dashboard
            );
          }
        } else {
          ErrorToast(
            "Error message",
            "Submission failed! Please fill in all required fields and try again."
          );
          set_errors(res?.errors || {});
        }
      });
    } catch (error) {
      set_loader(false); // Hide loader on error
      console.error("Error Updating logbook:", error);
    }
  };

  const VIEW_AUXILARY_MACHINARY_DETAILS_LOGBOOK_API = async (other_id, voyage_id) => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("other_id", Number(other_id) || 0);
      FORM_DATA.append("eng_log_basic_id", eng_log_basic_id);
      FORM_DATA.append("voyage_id", voyage_id?.voyage_details?.[0]?.id);

      set_loader(true);
      post(ApiURL.view_update_other_machinery, FORM_DATA).then((res) => {
        set_loader(false);

        const machinery_Data = res?.other_machine_data;

        if (res?.status === true) {
          // Set common state
          set_Update_Status(machinery_Data?.complete_status);
          setSubmitStatus(machinery_Data?.submit_status);
          setChecked(machinery_Data?.other_on_off);
          set_LogDate(machinery_Data?.date_time_log || moment().format("YYYY-MM-DD HH:mm:ss"));

          // Handle other parameters (merged with _items)
          const rawItemParams = _items?.other_parameters || [];
          const machineryParams = machinery_Data?.other_parameters || {};

          // Merge the two datasets (machinery and additional parameters)
          const mergedParams = rawItemParams.map((param) => {
            const paramName = param.name;
            const machineryEntry = machineryParams[paramName] || {};
            return {
              name: paramName,
              unit: param.unit || machineryEntry.unit || "",
              value: machineryEntry.value || "",
            };
          });

          const otherParamsData = Array.isArray(mergedParams) ? mergedParams : [];
          const initialOtherParams = otherParamsData.reduce((acc, param) => {
            acc[param.name] = {
              value: param.value || "",
              unit: param.unit || "",
            };
            return acc;
          }, {});

          setOtherParams(initialOtherParams);
        } else {
          set_errors(res?.errors || {});
        }
      });
    } catch (error) {
      set_loader(false); // Hide loader on error
      console.error("Error updating logbook:", error);
    }
  };

  const otherParameterUnits = [
    ...new Set(Object.values(otherParams || {}).map((param) => param.unit)),
  ];

  return (
    <>
      <div className="row custom-box">
        <div className="col-3">
          <b style={{ color: "#161515", fontSize: "14px" }}>
            Machinary Make:- {_items?.machinary_make}
          </b>
        </div>
        <div className="col-3">
          <b style={{ color: "#161515", fontSize: "14px" }}>
            Machinary Model:- {_items?.machinary_model}
          </b>
        </div>
        <div className="col-3">
          <b style={{ color: "#161515", fontSize: "14px" }}>
            Machinary Name :- {_items?.machinary_name}
          </b>
        </div>
        <div className="col-3">
          <b style={{ color: "#161515", fontSize: "14px" }}>Machinary Id:- {_items?.id}</b>
        </div>

        <div className="col-2">
          <Switch
            disabled={submitStatus}
            checked={checked}
            onChange={(value) => {
              setChecked(value);
              if (value || !value) {
                update_status
                  ? UPDATE_AUXILARY_MACHINARY_DETAILS_LOGBOOK_API(_items?.id, "0", value)
                  : ADD_AUXILARY_MACHINARY_DETAILS_LOGBOOK_API(_items?.id, value);
              }
            }}
            checkedChildren="On"
            unCheckedChildren="Off"
            style={{ backgroundColor: checked ? "green" : "red" }}
          />
        </div>
      </div>

      {checked && (
        <>
          {(() => {
            const rows = [];
            const otherParamsArray = Object.entries(otherParams || {});
            for (let i = 0; i < otherParamsArray.length; i += 3) {
              const group = otherParamsArray.slice(i, i + 3);
              rows.push(
                <div className="row" key={`other-row-${i}`}>
                  {group.map(([name, { value, unit }]) => (
                    <div className="col-4" key={name}>
                      <UnitWithInput
                        label={name}
                        value={value}
                        onChange={(e) => handleOtherParamChange(name, "value", e.target.value)}
                        unit={unit}
                        onUnitChange={(e) => handleOtherParamChange(name, "unit", e.target.value)}
                        disabled={submitStatus}
                        unitList={otherParameterUnits}
                      />
                    </div>
                  ))}
                  {group.length < 3 &&
                    Array.from({ length: 3 - group.length }).map((_, idx) => (
                      <div className="col-4" key={`empty-other-${i}-${idx}`}></div>
                    ))}
                </div>
              );
            }
            return rows;
          })()}

          <div
            className="row"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "15px",
              marginLeft: "5px",
            }}
          >
            {["Chief Engineer"].includes(user?.data?.designation) &&
              eng_log_basic_id && (
                <Button
                  disabled={submitStatus}
                  loading={loader}
                  className="save_btn"
                  style={{ color: "white" }}
                  onClick={() =>
                    update_status
                      ? UPDATE_AUXILARY_MACHINARY_DETAILS_LOGBOOK_API(_items?.id, "1", checked)
                      : ADD_AUXILARY_MACHINARY_DETAILS_LOGBOOK_API(_items?.id, checked)
                  }
                >
                  Submit
                </Button>
              )}
            <Button
              disabled={submitStatus}
              loading={loader}
              className="save_btn"
              style={{ color: "white" }}
              onClick={() =>
                update_status
                  ? UPDATE_AUXILARY_MACHINARY_DETAILS_LOGBOOK_API(
                      _items?.id,

                      "0",
                      checked
                    )
                  : ADD_AUXILARY_MACHINARY_DETAILS_LOGBOOK_API(_items?.id, checked)
              }
            >
              Save
            </Button>
          </div>
        </>
      )}
    </>
  );
};
